import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useLeave } from '../../../hooks/Features/useLeaves'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import { NoDataFound } from '../../NoDataFound'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function LeaveReport() {
  const { leave, loading, getLeaveReport } = useLeave()
  const [page, setPage] = useState(1)
  const startDate = new Date()
  startDate.setDate(1);
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    setPage(1)
    getLeaveReport({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(leave && leave.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'Area', key: 'area' },
    { label: 'TSM', key: 'tsm' },
    { label: 'KBC Name', key: 'kbcName' },
    { label: 'No. Of Leaves', key: 'noLeaves' },
  ]

  let tempLeave = []
  leave &&
    leave.forEach((item) =>
      tempLeave.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        area: item.area && item.area.name,
        tsm: item.rank5Name,
        kbcName: item.rank6Name,
        noLeaves: item.noOfLeaves,
      })
    )

  const headingOnClick = {
    'Number Of Leaves': () => {
      setFilterParams({ ...filterParams, noOfLeaves: filterParams.noOfLeaves === 1 ? -1 : 1 })
    },
  }

  return (
    <Layout
      heading="Leave Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempLeave ? tempLeave : []}
      tempHeaderData={[]}
      filename='leave_report'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            'Number Of Leaves': <SortIcon onClick={headingOnClick['Number Of Leaves']} value={filterParams.noOfLeaves} />,
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'area', 'TSM', 'KBC Name', 'Number Of Leaves']}
        />
        <TableBody className={styles.tr}>
          {!loading && leave.length > 0 &&
            leave.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.area ? item.area.name : '-----'} </TableCell>
                  <TableCell> {item.rank5Name ? item.rank5Name : '-----'} </TableCell>
                  <TableCell> {item.rank6Name ? item.rank6Name : '-----'} </TableCell>
                  <TableCell> {item.noOfLeaves ? item.noOfLeaves : '-----'} </TableCell>
                </CustomTableRow>
              )
            })
          }
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && leave.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && leave.length === 0 && <NoDataFound />}
    </Layout>
  )
}
